import axios from 'axios';
import {FieldInput} from 'components/fieldInput';
import {
  Animate,
  Grid,
  Icon,
  Loader,
  ViewContext,
} from 'components/lib';
import {stateOptions} from 'data';
import {Form, Formik} from 'formik';
import {Fragment, useContext, useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import * as Yup from 'yup';
import loader from './images/loader.gif';
import styles from './styles.module.scss';
import InputUtils from 'helpers/inputUtils';

export function Company(props) {
  const {id} = useParams();
  const context = useContext(ViewContext);
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [phone, setPhone] = useState('');

  async function runAPI() {
    setLoading(true);

    await axios
      .get(`/api/company/${id}`)
      .then((res) => {
        setLoading(false);
        setData(res.data.data);
        setPhone(res.data.data.phone);
      })
      .catch((err) => {
        setLoading(false);

        context.notification.show(
          'Failed to load dashboard data',
          'error',
          true,
          'toast',
          'x-circle'
        );
      });
  }

  const inputUtils = new InputUtils();
  const handleChangePhoneNumber = (event, handleChange) => {
    handleChange(event);
    setPhone(inputUtils.number(event.target.value, phone));
  };

  useEffect(() => {
    if (loading) return;

    runAPI();
  }, []);

  const validationSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email!'),
  });

  var api_error = false;

  return (
    <Animate type="pop">
      <div style={{display: 'flex'}}>
        <div
          style={{
            backgroundColor: 'black',
            width: '150px',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 10,
            fontSize: 16,
            fontWeight: 600,
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            cursor: 'default',
            height: 60,
          }}
        >
          Company
        </div>
        <Link to={`/app/company/${id}/contacts`}>
          <div
            style={{
              backgroundColor: '#EAEAEA',
              width: '150px',
              color: '#090E3480',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 10,
              fontSize: 16,
              fontWeight: 600,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              cursor: 'pointer',
              height: 60,
            }}
          >
            Contacts
          </div>
        </Link>
      </div>
      <Grid cols="1">
        <div className={styles.wrapper}>
          {data ? (
            <Formik
              validationSchema={validationSchema}
              enableReinitialize
              initialValues={{
                name: data.name ? data.name : '',
                dba_name: data.dba_name ? data.dba_name : '',
                dot_number: data.dot_number ? data.dot_number : '',
                owner_name: data.owner_name ? data.owner_name : '',
                email: data.email ? data.email : '',
                policy_renewal_date: data.policy_renewal_date
                  ? data.policy_renewal_date
                  : '',
                lead_source: data.lead_source ? data.lead_source : '',
                years_in_business: data.years_in_business
                  ? data.years_in_business
                  : '',
                status: data.status ? data.status : '',
                address: data.address ? data.address : '',
                address2: data.address2 ? data.address2 : '',
                city: data.city ? data.city : '',
                state: data.state ? data.state : '',
                zip: data.zip ? data.zip : '',
                garaging_address: data.garaging_address
                  ? data.garaging_address
                  : '',
                garaging_address2: data.garaging_address2
                  ? data.garaging_address2
                  : '',
                garaging_city: data.garaging_city
                  ? data.garaging_city
                  : '',
                garaging_state: data.garaging_state
                  ? data.garaging_state
                  : '',
                garaging_zip: data.garaging_zip
                  ? data.garaging_zip
                  : '',
              }}
              onSubmit={async (values) => {
                setUpdating(true);

                await axios
                  .put(`/api/company/${id}`, values)
                  .then((res) => {
                    setUpdating(false);

                    context.notification.show(
                      'Company updated!',
                      'success',
                      true,
                      'toast',
                      'check-circle'
                    );
                  })
                  .catch((err) => {
                    setUpdating(false);

                    context.notification.show(
                      err.response.data,
                      'error',
                      true,
                      'toast',
                      'x-circle'
                    );
                  });
              }}
            >
              {({
                  errors,
                  touched,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  submitForm,
                }) => (
                <Fragment>
                  <Form
                    className={styles.form}
                    onSubmit={handleSubmit}
                  >
                    <div className={styles.left}>
                      <div>
                        <h1
                          style={{
                            fontWeight: 600,
                            fontSize: 20,
                            marginBottom: 10,
                          }}
                        >
                          Company Info
                        </h1>
                        <div className={styles.fieldRow}>
                          <FieldInput
                            id="name"
                            type="text"
                            label="Company Name"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.name}
                            touched={touched.name}
                          />
                          <FieldInput
                            id="dba_name"
                            type="text"
                            label="DBA Name"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.dba_name}
                            touched={touched.dba_name}
                          />
                        </div>
                        <div className={styles.fieldRow}>
                          <FieldInput
                            id="dot_number"
                            type="text"
                            label="DOT Number"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.dot_number}
                            touched={touched.dot_number}
                          />
                        </div>
                        <div className={styles.fieldRow}>
                          <FieldInput
                            id="owner_name"
                            type="text"
                            label="Owner Name"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.owner_name}
                            touched={touched.owner_name}
                          />
                        </div>
                      </div>
                      <div>
                        <h1
                          style={{
                            fontWeight: 600,
                            fontSize: 20,
                            marginBottom: 10,
                          }}
                        >
                          Contact Info
                        </h1>
                        <div className={styles.fieldRow}>
                          <FieldInput
                            id="email"
                            type="text"
                            label="Email"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.email}
                            touched={touched.email}
                          />
                          <FieldInput
                            id="phone"
                            type="phone"
                            label="Phone"
                            handleChange={(event) => {
                              handleChangePhoneNumber(
                                event,
                                handleChange
                              );
                            }}
                            value={phone}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.phone}
                            touched={touched.phone}
                          />
                        </div>
                        <div className={styles.fieldRow}>
                          <FieldInput
                            id="policy_renewal_date"
                            type="date"
                            label="Policy Renewal Date"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.policy_renewal_date}
                            touched={touched.policy_renewal_date}
                          />
                          <FieldInput
                            id="lead_source"
                            type="text"
                            label="Lead Source"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.lead_source}
                            touched={touched.lead_source}
                          />
                        </div>
                        <div className={styles.fieldRow}>
                          <FieldInput
                            id="years_in_business"
                            type="text"
                            label="Years in Business"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.years_in_business}
                            touched={touched.years_in_business}
                          />
                          <FieldInput
                            id="status"
                            type="select"
                            label="Status"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.status}
                            touched={touched.status}
                            options={[
                              {
                                label: 'Active/Lead',
                                value: 'lead',
                              },
                              {
                                label: 'Pending Cancellation',
                                value: 'pending_cancellation',
                              },
                              {
                                label: 'Cancelled',
                                value: 'cancelled',
                              },
                            ]}
                          />
                        </div>
                      </div>
                    </div>
                    <div className={styles.right}>
                      <div>
                        <h1
                          style={{
                            fontWeight: 600,
                            fontSize: 20,
                            marginBottom: 10,
                          }}
                        >
                          Mailing Address
                        </h1>
                        <div className={styles.fieldRow}>
                          <FieldInput
                            id="address"
                            type="text"
                            label="Mailing Address"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.address}
                            touched={touched.address}
                          />
                        </div>
                        <div className={styles.fieldRow}>
                          <FieldInput
                            id="address2"
                            type="text"
                            label="Mailing Address Line 2"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.address2}
                            touched={touched.address2}
                          />
                        </div>
                        <div className={styles.fieldRow}>
                          <FieldInput
                            id="city"
                            type="text"
                            label="City"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.city}
                            touched={touched.city}
                          />
                          <FieldInput
                            id="state"
                            type="select"
                            label="State"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.state}
                            touched={touched.state}
                            options={stateOptions}
                          />
                          <FieldInput
                            id="zip"
                            type="text"
                            label="ZIP Code"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.zip}
                            touched={touched.zip}
                          />
                        </div>
                      </div>
                      <div>
                        <h1
                          style={{
                            fontWeight: 600,
                            fontSize: 20,
                            marginBottom: 10,
                          }}
                        >
                          Garaging Address
                        </h1>
                        <div className={styles.fieldRow}>
                          <FieldInput
                            id="garaging_address"
                            type="text"
                            label="Garaging Address"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.garaging_address}
                            touched={touched.garaging_address}
                          />
                        </div>
                        <div className={styles.fieldRow}>
                          <FieldInput
                            id="garaging_address2"
                            type="text"
                            label="Garaging Address Line 2"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.garaging_address2}
                            touched={touched.garaging_address2}
                          />
                        </div>
                        <div className={styles.fieldRow}>
                          <FieldInput
                            id="garaging_city"
                            type="text"
                            label="City"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.garaging_city}
                            touched={touched.garaging_city}
                          />
                          <FieldInput
                            id="garaging_state"
                            type="select"
                            label="State"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.garaging_state}
                            touched={touched.garaging_state}
                            options={stateOptions}
                          />
                          <FieldInput
                            id="garaging_zip"
                            type="text"
                            label="ZIP Code"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            showErrors
                            errors={errors.garaging_zip}
                            touched={touched.garaging_zip}
                          />
                        </div>
                      </div>
                    </div>
                  </Form>
                  <div
                    className={styles.footer}
                    style={
                      api_error
                        ? {justifyContent: 'space-between'}
                        : {justifyContent: 'flex-end'}
                    }
                  >
                    {api_error && (
                      <div className={styles.errorMessage}>
                        <div className={styles.icon}>
                          <Icon image="alert-circle"/>
                        </div>
                        <span>
                          Something went wrong, check the fields.
                        </span>
                      </div>
                    )}
                    <div className={styles.buttons}>
                      <button
                        className={styles.save}
                        onClick={!updating ? submitForm : null}
                        style={
                          updating
                            ? {cursor: 'default'}
                            : {cursor: 'pointer'}
                        }
                      >
                        {updating ? (
                          <img
                            src={loader}
                            alt="loader"
                            style={{width: 25}}
                          />
                        ) : (
                          'Save'
                        )}
                      </button>
                    </div>
                  </div>
                </Fragment>
              )}
            </Formik>
          ) : (
            <Loader/>
          )}
        </div>
      </Grid>
    </Animate>
  );
}
